module.exports = __webpack_public_path__ + "assets/img/driver-btn-30cc78f0.png";